<template>
  <div class="operate-table-details">
    <gj-table
        :data="data"
        :columns="columns"
        :adapt-height="false"
        :index="false"
    >
      <template v-slot:asin="{ row }">
        <gj-link :href="row.asinUrl" target="_blank">{{ row.asin | defaultShow }}</gj-link>
        <gj-copy-icon v-if="row.asin" :content="row.asin"></gj-copy-icon>
      </template>
      <template v-slot:fulfillableDay="{ row }">
        <span v-if="row.fulfillableDay === 0" style="color: #F5222D;">缺货</span>
        <div v-else>FBA库存可售天数不足<span style="color: #F5222D;">{{ row.fulfillableDay | defaultShow}}</span>天</div>
      </template>
      <template v-slot:slowsalesRate="{ row }">
        <span>{{ row.slowsalesRate | defaultShow }} %</span>
      </template>
      <template v-slot:marketName="{ row }">
        <span v-if="row.marketName">{{ row.marketName.split(':')[0] }}/{{ row.marketName.split(':')[1] }}</span>
        <span v-else>-</span>
      </template>
    </gj-table>
  </div>
</template>

<script>
import {allColumns} from "@/views/modules/message/message-center/components/columns";

export default {
  name: "operate-table-details",
  props: {
    data: {
      type: [Array, Object],
      default: null
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  },
  created() {
    this.columns = allColumns[this.warnTitleCode] || [];
  },
  data() {
    return {
      columns: []
    }
  },
}
</script>

<style scoped lang="scss">
//.operate-table-details {
//  padding-right: 60px;
//}
</style>
